module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6aab923ab87e1998c1e7fefb2b3c9829.png";